import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
    Navigation: [],
    loading: false
};

const fetchNavigationStart = ( state, action ) => {
    return updateObject( state, { loading: true } );
};

const fetchNavigationSuccess = ( state, action ) => {
    return updateObject( state, {
        Navigation: action.Navigation,
        loading: false
    } );
};

const fetchNavigationFail = ( state, action ) => {
    return updateObject( state, { loading: false } );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.FETCH_Navigation_START: return fetchNavigationStart( state, action );
        case actionTypes.FETCH_Navigation_SUCCESS: return fetchNavigationSuccess( state, action );
        case actionTypes.FETCH_Navigation_FAIL: return fetchNavigationFail( state, action );
        default: return state;
    }
};

export default reducer;